module.exports = __webpack_public_path__ + "img/stvrt-mapa-centrum.fff0ab67.jpg";